"use strict";
/** state: Final **/
/** family: Modal **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
/**
 * Title for the Modal Header
 *
 * To default the tag to h2 and to support sub title in Modal Header, had to re-implement this class
 *
 * @param {ModalTitleProps} props
 * @returns {any}
 * @constructor
 */
var ModalTitle = /** @class */ (function (_super) {
    __extends(ModalTitle, _super);
    function ModalTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalTitle.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, restProps = __rest(_a, ["className", "children"]);
        return (React.createElement("h2", __assign({ className: classNames('modal-title', className) }, restProps), children));
    };
    return ModalTitle;
}(React.Component));
exports.ModalTitle = ModalTitle;
/**
 * Sub Title inside Model Header Title
 *
 * To default tag to p and to ensure there is a semantic class for a subtitle
 *
 * @param {ModalTitleProps} props
 * @returns {any}
 * @constructor
 */
var ModalSubtitle = function (_a) {
    var className = _a.className, children = _a.children, restProps = __rest(_a, ["className", "children"]);
    return (React.createElement("p", __assign({ className: classNames('modal-subtitle h2', className) }, restProps), children));
};
exports.ModalSubtitle = ModalSubtitle;
//# sourceMappingURL=ModalTitle.js.map